import { TCompanyProfile, THarmonicTeamMember, TMarketReport, TPatents } from "@/libs/models/companies";

import { TCompetitor, TInnoveraCompany, TParsingStatus } from "@/libs/models/portfolio-companies";

import { TNewFinancialStage } from "@/libs/models/shared";

export type FinancialStage = TNewFinancialStage;

export type TFounderInfo = {
  founderPresent: boolean;
  investorAccess: EInvestorAccess | null;
  investorAccessStatus: EInvestorAccessStatus | null;
  isDataRoomPending: boolean;
};

export type TInvestor = {
  firstName: string;
  lastName: string;
  profileImageUrl: string;
  email: string;
  organization: {
    name: string;
    id: number;
    profilePhotoImgUrl: string;
  };
};

export type THarmonicInvestor = {
  name: string;
  type: string;
  imageUrl: string | null;
};

export type TCompanyHeaderInfo = {
  id: number;
  name: string;
  logoUrl: string | null;
  headline: string | null;
  website: string | null;
  twitterUrl: string | null;
  linkedInUrl: string | null;
  facebookUrl: string | null;
  phone: string | null;
  email: string | null;
  harmonicTags: string[];
  companyId: number;
};

export type { TInnoveraCompany } from "@/libs/models/portfolio-companies";
export type { TCompanyProfile } from "@/libs/models/companies";
export type TCompanyComparedDetails = {
  businessModels?: any;
  city: string;
  angelListUrl?: string;
  country: string;
  description: string;
  facebookUrl?: string;
  financialStage?: any;
  foundingDate?: string;
  fundingRoundsCount?: number;
  githubUrl?: string;
  harmonicInvestors?: { name: string; type: string }[];
  harmonicTags?: string[];
  headcount?: number;
  headline: string;
  id: number;
  instagramUrl?: string;
  lastFundingAmount?: number;
  lastFundingDate?: string;
  linkedInUrl?: string;
  logoUrl?: string;
  name: string;
  productHuntUrl?: string;
  state: string;
  totalFunding?: number;
  twitterUrl?: string;
  website: string;
  email?: string;
  hasInnoveraData?: boolean;
  hasPitchdeckData?: boolean;
  industries?: any;
  marketDescription?: any;
  parsedCompetitors?: any[];
  parsingMessage?: any;
  parsingProgress?: number;
  parsingStatus?: string;
  phone?: string;
  sam?: any;
  solutionDescription?: any;
  som?: any;
  stage?: { id: number; name: string };
  tags?: string[];
  tam?: any;
  teamMembers?: { id: number; firstName: string; lastName: string; title?: string }[];
  [key: string]: any;
};

export type { TPatent } from "@/libs/models/companies";

export type TPatentsData = TPatents;

export enum EDataRoomSection {
  TEAM_DOCUMENTS = "Team Documents",
  CUSTOMERS_AND_PARTNERS = "Customers & Partners",
  SALES_AND_MARKETING = "Sales & Marketing",
  FINANCIALS = "Financials",
  MARKET_AND_COMPETITION = "Market & Competition",
  PRODUCT_AND_TECHNOLOGY = "Product & Technology",
  LEGAL = "Legal",
  OTHER = "Other"
}

export type Competitor = TCompetitor;

export enum EDataStatus {
  processing = "processing",
  done = "done",
  matching_done = "matching_done",
  error = "error",
  parsing = "parsing"
}

export enum EActiveView {
  PROFILE = "Profile",
  DATA_ROOM = "Data Room",
  ANNOTATIONS = "Annotations"
}

export type TMarketLandscapeSectionData = {
  city: string;
  country: string;
  financeStage: string;
  headline: string;
  id: number;
  logoUrl: string;
  name: string;
  state: string;
  totalFunding: number;
  valuation: number;
  website: string;
}[];

export type { TProduct } from "@/libs/models/companies";

export type { TProducts as TProductsData } from "@/libs/models/companies";

export enum EAccessDataStatus {
  FULL_DATA = "full_data",
  NO_ACCESS = "no_access",
  PENDING_REQUEST = "pending_request",
  NO_FOUNDER = "no_founder",
  PROFILE_DATA = "profile_data"
}

export enum EInvestorAccess {
  FULL = "Full",
  PROFILE = "Profile"
}

export enum EInvestorAccessStatus {
  APPROVED = "approved",
  PENDING = "pending"
}

type Tag = {
  id: number;
  name: string;
};

export type { TSimilarCompany } from "@/libs/models/companies";

export type TCompany = {
  id: number;
  name: string;
  logoUrl: string | null;
  headline: string;
  foundingDate?: string;
  financialStage: FinancialStage | null;
  totalFunding: bigint | null;
  valuation: bigint | null;
  country: string | null;
  state: string | null;
  city: string | null;
  investors: any[] | null;
  team: any[] | null;
  harmonicInvestors?: TInvestor[] | null;
  tags: Tag[] | null;
};

export type TTableCompany = {
  id: number;
  name: string | null;
  logoUrl: string | null;
  headline: string | null;
  foundingDate?: string | Date | null;
  financialStage: FinancialStage | null;
  totalFunding: bigint | null;
  valuation: bigint | null;
  country: string | null;
  state: string | null;
  city: string | null;
  investors: string[] | null;
};

export type { TSimilarCompaniesResponse } from "@/libs/models/companies";

export type TCompaniesDataResponse = {
  companies: TCompany[];
  totalCompanies: number;
  hasNext: boolean;
  hasPrev: boolean;
};

export type TTeamMember = THarmonicTeamMember;

export type TCompetitorsDataResponse = {
  data: Competitor[];
  meta: {
    parsingStatus: TParsingStatus;
  };
};

export type TCompanyData = TInnoveraCompany;

export type TKeyFigure = {
  name: string;
  value: string;
  unit: string | null;
  comment: string;
};
export type TMarketReportData = TMarketReport;
